module.exports = __webpack_public_path__ + "static/history4-bf56eb8f04e906c338c929a98b28c2c1.jpg";